<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.edit_provider") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #3eb6d4">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-image-upload-input
            col="12"
            identifier="admin_image"
            :preSelectedImage="data.image.path"
            :placeholder="$t('PLACEHOLDERS.printerImage')"
            @selectImage="selectImage"
          />
          <!-- End:: Image Upload Input -->

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.name')"
            v-model.trim="data.name"
          />

          <base-input
            col="6"
            type="text"
            v-model="data.phone"
            :placeholder="$t('PLACEHOLDERS.phone')"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.commercial_register')"
            v-model.trim="data.commercial_register"
          />

          <base-select-input
            col="6"
            :placeholder="$t('PLACEHOLDERS.city')"
            v-model.trim="data.city"
            :optionsList="cities"
          />

          <!-- End:: Days Input -->
          <div class="col-12" v-if="isProviderLoading">
            <div class="d-flex justify-content-center my-5">
              <v-progress-circular
                indeterminate
                color="#3eb6d4"
                :size="40"
              />
            </div>
          </div>
          <div class="btn_wrapper" v-else>
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import BasePhoneInput from "@/components/formInputs/BasePhoneInput.vue";
import ChangableMapComponent from "../../../components/general/ChangableMapComponent.vue";

export default {
  computed: {
    businessActivityTypes() {
      return [
        { id: "restaurant", name: this.$t("BUSINESS_TYPE.restaurant") },
        { id: "cafe", name: this.$t("BUSINESS_TYPE.cafe") },
        {
          id: "hotel_restaurant",
          name: this.$t("BUSINESS_TYPE.hotel_restaurant"),
        },
        { id: "supermarket", name: this.$t("BUSINESS_TYPE.supermarket") },
      ];
    },
    deferredOptions() {
      return [
        { id: "yes", name: this.$t("PLACEHOLDERS.yes"), value: 1 },
        { id: "no", name: this.$t("PLACEHOLDERS.no"), value: 0 },
      ];
    },
  },
  name: "CreateClient",
  components: {
    BasePhoneInput,
    ChangableMapComponent,
  },
  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      isProviderLoading: false,
      // Start:: Data Collection To Send
      data: {
        postal_code: null,
        building_number: null,
        image: {
          path: null,
          file: null,
        

},
        name: null,
        iban: null,
        email: null,
        tax_number: null,
        phone: null,
        active: true,
        commercial_register: null,
        region: null,
        city: null,
      },
      cities: [],
      regions: [],
      neighborhoods: [],
      brands: [],
      // End:: Data Collection To Send
      dueDate: "",
    };
  },

  methods: {
    isoCode(iosCode) {
      this.data.iso_code = iosCode;
    },
    dialCode(dialCode) {
      this.data.dial_code = dialCode;
    },
    // Start:: Select Upload Image
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    // End:: Select Upload Image
    // Start:: Calculate Due Date

    // End:: Calculate Due Date
    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      this.submitForm();
    },
    // End:: validate Form Inputs
    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();

      if (this.data.name) {
        REQUEST_DATA.append("name", this.data.name);
      }

      if (this.data.phone) {
        REQUEST_DATA.append("mobile", this.data.phone);
      }

      if (this.data.commercial_register) {
        REQUEST_DATA.append(
          "commercial_registration",
          this.data.commercial_register
        );
      }

      if (this.data.image.file != null) {
        REQUEST_DATA.append("avatar", this.data.image.file);
      }

      if (this.data.city) {
        REQUEST_DATA.append("city_id", this.data.city.id);
      }

      REQUEST_DATA.append("_method", "PUT");
      // Start:: Append Request Data

      try {
        await this.$axios({
          method: "POST",
          url: `printShops/${this.$route.params?.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/providers/all" });
        this.getData();
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      
        this.loading = false;}
    },
    // End:: Submit Form

    async getData() {
      try {
        this.isProviderLoading = true;
        let res = await this.$axios({
          method: "GET",
          url: `printShops/${this.$route.params?.id}`,
        });
        this.data.name = res.data.data?.PrintShop?.user.name;
        this.data.phone = res.data.data?.PrintShop?.user.mobile;
        this.data.commercial_register =
          res.data.data?.PrintShop?.user.commercial_registration;
        this.data.image.path = res.data.data?.PrintShop?.user.avatar;
        this.data.city = res.data.data?.PrintShop?.user.city;

        // End:: Set Data
      } catch (error) {
        console.log(error.response.data.message);
      } finally {
        this.isProviderLoading = false;
      }
    },

    async getCities() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `cities?page=0&limit=0&is_active=1`,
        });
        this.cities = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      
        this.loading = false;}
    },
  },

  async created() {
    await this.getCities();
    await this.getData();
  },
};
</script>
